import React, { useState, useEffect, useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { Box, Card, CircularProgress, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import {
  STUDENT_RESEARCH_STATUS,
  STUDENT_RESEARCH_STATUS_LABEL,
} from "../../../constants/projectStatus";

// Bảng màu lặp cho pie chart. Giới hạn đủ cho ~20 status.
const COLORS = [
  "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40",
  "#C9CBCF", "#BA68C8", "#81C784", "#E57373", "#4DB6AC", "#7986CB",
  "#FFB74D", "#A1887F", "#90A4AE", "#F06292", "#4FC3F7", "#AED581",
  "#FFD54F", "#B39DDB",
];

// emptyState: khởi tạo map {status: 0} cho mọi status của state machine mới.
const emptyState = () =>
  STUDENT_RESEARCH_STATUS.reduce((acc, s) => ({ ...acc, [s]: 0 }), {});

function StudentProjectStatistics(props) {
  const [statisticsData, setStatisticsData] = useState(emptyState);

  useEffect(() => {
    const next = emptyState();
    (props.studentResearchList || []).forEach((project) => {
      // status có thể ở dạng string hoặc array {value, label}.
      let arr = project.status;
      if (typeof project.status === "string") arr = project.status.split(",");
      if (!arr || arr.length === 0) return;

      const latest = arr[arr.length - 1];
      const value = typeof latest === "object" ? latest?.value : latest;
      if (value && next.hasOwnProperty(value)) next[value]++;
    });
    setStatisticsData(next);
  }, [props.studentResearchList]);

  const chartData = useMemo(() => {
    const labels = [];
    const data = [];
    const backgroundColor = [];
    let idx = 0;
    Object.keys(statisticsData).forEach((key) => {
      if (statisticsData[key] > 0) {
        labels.push(STUDENT_RESEARCH_STATUS_LABEL[key] || key);
        data.push(statisticsData[key]);
        backgroundColor.push(COLORS[idx % COLORS.length]);
        idx++;
      }
    });
    return { labels, datasets: [{ data, backgroundColor }] };
  }, [statisticsData]);

  const totalProjects = Object.values(statisticsData).reduce((a, b) => a + b, 0);

  const pieOptions = {
    title: { display: false },
    legend: { position: "bottom", labels: { fontSize: 11, boxWidth: 15 } },
    maintainAspectRatio: false,
  };

  return (
    <Card style={{ height: "100%", padding: "12px 16px", display: "flex", flexDirection: "column" }}>
      {props.isFetching ? (
        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box style={{ marginBottom: 8 }}>
            <Typography variant="h6" style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>
              Thống kê đề tài theo trạng thái
            </Typography>
          </Box>
          <Box style={{ flex: 1, minHeight: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
            {totalProjects > 0 ? (
              <div style={{ width: "100%", height: "100%" }}>
                <Pie data={chartData} options={pieOptions} />
              </div>
            ) : (
              <Typography variant="body2" color="textSecondary">
                Không có dữ liệu để hiển thị
              </Typography>
            )}
          </Box>
          <Box style={{ textAlign: "center", marginTop: 8 }}>
            <Typography variant="body2" style={{ fontSize: 13 }}>
              <strong>Tổng số đề tài: {totalProjects}</strong>
            </Typography>
          </Box>
        </>
      )}
    </Card>
  );
}

const mapStateToProps = (state) => ({
  studentResearchList: select(state, "studentResearchReducer", "list"),
  isFetching: select(state, "studentResearchReducer", "isFetching"),
});

export default connect(mapStateToProps, null)(toJs(StudentProjectStatistics));
